import { render, staticRenderFns } from "./LeaderboardLockedTeamListComponent.vue?vue&type=template&id=55994415&scoped=true&"
import script from "./LeaderboardLockedTeamListComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardLockedTeamListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardLockedTeamListComponent.vue?vue&type=style&index=0&id=55994415&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55994415",
  null
  
)

export default component.exports